((globalCore) => {

  /**
  * Функции отвечающие за работу с преопределенными датами.
  * @namespace Core.requisites
  * @since 5.8.2.9000
  */
  globalCore.datePeriodRequisite = {

    DATE_TYPE: {
      DIFFERENT: {
        DAY: 0, // За день.
        RANGE: 1 // За период.
      },
      PRESET: {
        TODAY: 2, // Сегодня.
        YESTERDAY: 3, // Вчера.
        TOMORROW: 4, // Завтра.
        THIS_WEEK: 5, // На этой неделе.
        THIS_MONTH: 6, // В этом месяце.
        THIS_YEAR: 7, // В этом году.
        LAST_MONTH: 8, // В прошлом месяце.
        LAST_WEEK: 9, // На прошлой неделе.
        NEXT_WEEK: 10, // На следующей неделе.
        NEXT_MONTH: 11 // В следующем месяце.
      }
    },

    /**
    * Функция возвращает обертку над контролом выбора периода.
    * since 5.8.2.9000
    * @method Core.requisites.datePeriodRequisite.getDateWrapper
    * @param {object} el Выбранный элемент.
    */
    _getDateWrapper: (el) => {
      return $(el).parents('.Search_Date_Row');
    },

    /**
    * Функция обрабатывает вызов списка предопределенных значений.
    * since 5.8.2.9000
    * @method Core.requisites.datePeriodRequisite.clickOnToggle
    * @param {object} el Выбранный элемент.
    */
    clickOnToggle: (el) => {
      let jDateCriteriaList = Core.requisites.datePeriodRequisite._getDateWrapper(el).find('.date-criteria-list');
      if (jDateCriteriaList.length > 0) {
        let dateCriteriaList = jDateCriteriaList[0];

        //пересчет высоты выпадающего списка, если он выходит за границы по высоте.
        const searchCriteriaTop = $(el).position().top + 82;
        const containerHeight = $('#left_container').height();
        const dateCriteriaListHeight = jDateCriteriaList.height();
        const heightDiff = searchCriteriaTop + dateCriteriaListHeight - containerHeight;
        if (heightDiff > 0) {
          jDateCriteriaList.height(dateCriteriaListHeight - heightDiff);
          jDateCriteriaList.css('overflow-y', 'scroll');
        }

        dateCriteriaList.style.top = searchCriteriaTop + 'px';
        if (!dateCriteriaList.classList.contains('active')) {
          dateCriteriaList.classList.add('active');
        }

        let jActiveDateCriteriaList = $('div.date-criteria-list.active');
        if (jActiveDateCriteriaList.length > 0) {
          jActiveDateCriteriaList.attr('tabindex', -1).focusout(() => {
            jActiveDateCriteriaList[0].classList.remove('active');
          });
          jActiveDateCriteriaList.focus();
        }
      }
    },

    /**
    * Функция обрабатывает выбор предопределенного значения.
    * since 5.8.2.9000
    * @method Core.requisites.datePeriodRequisite.selectPreset
    * @param {object} el Выбранный элемент.
    */
    selectPreset: (el) => {
      const jSearchDateRow = Core.requisites.datePeriodRequisite._getDateWrapper(el);

      let jIsSingleDateActiveElement = jSearchDateRow.find('.isSingleDateActive');
      if (jIsSingleDateActiveElement.length > 0 && jIsSingleDateActiveElement.val() === 'true') {
        //в режиме выбора одиночной даты нельзя выбрать предопределенное значение.
        return;
      }

      const jDates = jSearchDateRow.find('.Search_Date_TD');

      let jDateCriteriaList = jSearchDateRow.find('.date-criteria-list');
      if (jDateCriteriaList.length > 0) {
        jDateCriteriaList[0].classList.remove('active');
      }

      if (jDates.length > 0) {
        let jStartDateInput = $(jDates[0]).find('input');
        let jEndDateInput = $(jDates[1]).find('input');
        if (jStartDateInput.length > 0 && jEndDateInput.length > 0) {
          let today = new Date();
          const dayNum = today.getDay();
          const dayOfWeek = dayNum === 0 ? 7 : dayNum;

          const presetValue = parseInt(el.attributes['data-key'].value, 10);
          switch (presetValue) {
            // Сегодня.
            case Core.requisites.datePeriodRequisite.DATE_TYPE.PRESET.TODAY:
              jStartDateInput[0].value = formatDate(today);
              jEndDateInput[0].value = formatDate(today);
              break
            // Вчера.
            case Core.requisites.datePeriodRequisite.DATE_TYPE.PRESET.YESTERDAY:
              const yesterday = (new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1));
              jStartDateInput[0].value = formatDate(yesterday);
              jEndDateInput[0].value = formatDate(yesterday);
              break
            // Завтра.
            case Core.requisites.datePeriodRequisite.DATE_TYPE.PRESET.TOMORROW:
              const tomorrow = (new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1));
              jStartDateInput[0].value = formatDate(tomorrow);
              jEndDateInput[0].value = formatDate(tomorrow);
              break
            // На этой неделе.
            case Core.requisites.datePeriodRequisite.DATE_TYPE.PRESET.THIS_WEEK:
              jStartDateInput[0].value = formatDate(new Date(today.getFullYear(), today.getMonth(), today.getDate() - dayOfWeek + 1));
              jEndDateInput[0].value = formatDate(today);
              break
            // В этом месяце.
            case Core.requisites.datePeriodRequisite.DATE_TYPE.PRESET.THIS_MONTH:
              let thisMonth = new Date();
              thisMonth.setDate(1);
              jStartDateInput[0].value = formatDate(thisMonth);
              jEndDateInput[0].value = formatDate(today);
              break
            // В этом году.
            case Core.requisites.datePeriodRequisite.DATE_TYPE.PRESET.THIS_YEAR:
              let thisYear = new Date();
              thisYear.setDate(1);
              thisYear.setMonth(0);
              jStartDateInput[0].value = formatDate(thisYear);
              jEndDateInput[0].value = formatDate(today);
              break
            // В прошлом месяце.
            case Core.requisites.datePeriodRequisite.DATE_TYPE.PRESET.LAST_MONTH:
              jStartDateInput[0].value = formatDate(new Date(today.getFullYear(), today.getMonth() - 1, 1));
              jEndDateInput[0].value = formatDate(new Date(today.getFullYear(), today.getMonth(), 0));
              break
            // На прошлой неделе.
            case Core.requisites.datePeriodRequisite.DATE_TYPE.PRESET.LAST_WEEK:
              jStartDateInput[0].value = formatDate(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7 - dayOfWeek + 1));
              jEndDateInput[0].value = formatDate(new Date(today.getFullYear(), today.getMonth(), today.getDate() - dayOfWeek));
              break
            // На следующей неделе.
            case Core.requisites.datePeriodRequisite.DATE_TYPE.PRESET.NEXT_WEEK:
              jStartDateInput[0].value = formatDate(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7 - dayOfWeek + 1));
              jEndDateInput[0].value = formatDate(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14 - dayOfWeek));
              break
            // В следующем месяце.
            case Core.requisites.datePeriodRequisite.DATE_TYPE.PRESET.NEXT_MONTH:
              jStartDateInput[0].value = formatDate(new Date(today.getFullYear(), today.getMonth() + 1, 1));
              jEndDateInput[0].value = formatDate(new Date(today.getFullYear(), today.getMonth() + 2, 0));
              break
          }
        }
      }
    },

    /**
    * Функция обрабатывает изменения типа отображаемой даты.
    * since 5.8.2.9000
    * @method Core.requisites.datePeriodRequisite.changeType
    * @param {object} el Выбранный элемент.
    */
    changeType: (el) => {
      const jSearchDateRow = Core.requisites.datePeriodRequisite._getDateWrapper(el);
      if (jSearchDateRow.length > 0) {
        let jDateCriteriaList = jSearchDateRow.find('.date-criteria-list');
        let jPresetItems = jDateCriteriaList.find('.preset-item');
        if (jDateCriteriaList.length > 0) {
          jDateCriteriaList[0].classList.remove('active');
        }

        const searchDateRow = jSearchDateRow[0];
        let jIsSingleDateActiveElement = jSearchDateRow.find('.isSingleDateActive');

        const differentValue = parseInt(el.attributes['data-key'].value, 10);
        switch (differentValue) {
          case Core.requisites.datePeriodRequisite.DATE_TYPE.DIFFERENT.DAY:
            jIsSingleDateActiveElement.val('true');
            if (!searchDateRow.classList.contains('singleDate')) {
              searchDateRow.classList.add('singleDate');
            };
            if (!jPresetItems.hasClass('disabled')) {
              jPresetItems.addClass('disabled');
            }
            break
          case Core.requisites.datePeriodRequisite.DATE_TYPE.DIFFERENT.RANGE:
            jIsSingleDateActiveElement.val('false');
            if (searchDateRow.classList.contains('singleDate')) {
              searchDateRow.classList.remove('singleDate');
            };
            if (jPresetItems.hasClass('disabled')) {
              jPresetItems.removeClass('disabled');
            }
            break
        }
      }
    },

    /**
    * Функция обрабатывает изменения типа отображаемой даты.
    * since 5.8.2.9000
    * @method Core.requisites.datePeriodRequisite.pickSingleDate
    * @param {string} dateText Строковое значение выбранное в датапикере.
    * @param {object} el Выбранный элемент.
    */
    pickSingleDate: (el) => {
      const dateText = el.querySelector(".Req_Input").value;
      const jHiddenDates = Core.requisites.datePeriodRequisite._getDateWrapper(el).find('.Search_Date_TD');
      let jHiddenStartDateInput = $(jHiddenDates[0]).find('input');
      let jHiddenEndDateInput = $(jHiddenDates[1]).find('input');
      if (jHiddenStartDateInput.length > 0 && jHiddenEndDateInput.length > 0) {
        jHiddenStartDateInput[0].value = dateText;
        jHiddenEndDateInput[0].value = dateText;
      }
    },

  };

})(window.Core.requisites);